import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {putLabelToRemove} from '../../../../../../../../../../../../../../../../../actions/contactActions';
import {labelStateUpdating} from '../../../../../../../../../../../../../../../../../actions/contactsGroupItemActions';
import Button from '../../../../../../../../../../../../../../../../components/button';

function RemoveFromLabelButton ({contactId, contactType, disabled, title}) {

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const selectedContacts = useSelector(state => state.contactReducer.selectedContacts);

	const dispatch = useDispatch();

	const removeFromLabelHandler = (e) => {
		e.stopPropagation();
		dispatch(labelStateUpdating(selectedContactsGroup.id));
		let contactIds = [];
		if (selectedContacts.length) {
			contactIds = selectedContacts
		} else {
			contactIds.push({id: e.currentTarget.dataset.contactId})
		}

		dispatch(putLabelToRemove(
			contactIds,
			[selectedContactsGroup.id]
		))
	};

	return (
		<Button
			className="btn-link"
			title={title || ''}
			data-contact-id={contactId}
			data-contact-type={contactType}
			onClick={ removeFromLabelHandler }
			disabled={disabled}
		>
			<div className="more-option-item__picto">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path fill="currentColor" d="M 20.796 16.369 L 19.049 14.563 C 19.825 14.35 20.456 13.937 20.942 13.325 C 21.427 12.714 21.67 12 21.67 11.184 C 21.67 10.214 21.33 9.388 20.651 8.709 C 19.971 8.029 19.146 7.689 18.175 7.689 L 13.515 7.689 L 13.515 5.359 L 18.175 5.359 C 19.786 5.359 21.16 5.927 22.296 7.063 C 23.432 8.199 24 9.573 24 11.184 C 24 12.291 23.714 13.311 23.141 14.243 C 22.568 15.175 21.786 15.883 20.796 16.369 Z M 16.835 12.35 L 14.505 10.019 L 17.01 10.019 L 17.01 12.35 L 16.835 12.35 Z M 21.437 23.534 L 0 2.097 L 1.631 0.466 L 23.068 21.903 L 21.437 23.534 Z M 11.184 17.01 L 6.524 17.01 C 4.913 17.01 3.539 16.442 2.403 15.306 C 1.267 14.17 0.699 12.796 0.699 11.184 C 0.699 9.845 1.107 8.65 1.922 7.602 C 2.738 6.553 3.786 5.864 5.068 5.534 L 7.223 7.689 L 6.524 7.689 C 5.553 7.689 4.728 8.029 4.049 8.709 C 3.369 9.388 3.029 10.214 3.029 11.184 C 3.029 12.155 3.369 12.981 4.049 13.66 C 4.728 14.34 5.553 14.68 6.524 14.68 L 11.184 14.68 L 11.184 17.01 Z M 7.689 12.35 L 7.689 10.019 L 9.583 10.019 L 11.884 12.35 L 7.689 12.35 Z" />
				</svg>
			</div>
			<div className="more-option-item__text">
				<span>{title}</span>
			</div>
		</Button>
	);

}

export default RemoveFromLabelButton;
